<template>
    <div id="ModalShowData" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog modal-el">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('words.details_data')}}: <b>{{description}}</b></h5>
                    <button type="button"  class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover" id="showTable">
                            <tbody>
                                <tr v-for="(item, i) in headers" :key="i">
                                    <th class="col-md-3">{{item}}</th>
                                    <td><span v-html="data[i]"></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row">                        
                  <div class="col-md-6">
                    <div class="form-group">                  
                    <label>Dados Antes</label>
                    <textarea disabled class="form-control text-red" rows="12" v-model="oldData">

                    </textarea>
                      </div>
                      </div>
                         <div class="col-md-6">
                      <div class="form-group">
                    <label>Dados Depois</label>
                    <textarea disabled class="form-control text-green" rows="12" v-model="newData">

                    </textarea>
                      </div>
                        </div>
                </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button"  data-dismiss="modal" class="btn btn-default"><i class="fa fa-times"></i>
                        {{$t('words.close')}} </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    data: Array,
    headers: Array,
    description: String,
    oldData: String,
    newData: String
  }
};
</script>